// The organisation area's Audit log screen (spec/13 §15, F-ORG-14): every recorded action in this
// organisation that changed money, time, access or configuration, or read something sensitive —
// newest first, filtered by actor, action, target, venue, grant, request id and date, with a CSV
// export. Gated on `audit:read` (spec/07 §11.2, F-IAM-11); the server refuses a direct request with
// `403` regardless.

import { useTranslation } from '@clavian/i18n/react';
import type { ReactNode } from 'react';

import { useAccess } from '../../api/queries';
import { useScopeIds } from '../../shell/scope';
import { Forbidden, Page, TableSkeleton } from '../../ui';
import { AuditLog } from './AuditLog';

const AUDIT_READ = 'audit:read';

/** `/o/{orgSlug}/audit`. */
export function AuditLogPage(): ReactNode {
  const { t } = useTranslation('console');
  const scope = useScopeIds();
  const access = useAccess(scope.access);

  return (
    <Page title={t('audit.title')} description={t('audit.intro')}>
      {access.status === 'loading' ? (
        <TableSkeleton rows={8} label={t('audit.rows.loading')} />
      ) : access.can(AUDIT_READ) ? (
        <AuditLog organizationId={scope.organizationId} />
      ) : (
        <Forbidden message={t('audit.notPermitted')} />
      )}
    </Page>
  );
}
